import React from "react";
import UpPricing from "../components/UpPricing";
import Banner from "../components/Banner";

const PricingPage = () => {
  return (
    <>
      <UpPricing />
      <Banner />
    </>
  );
};

export default PricingPage;
